import { useLocation, Link as RouterLink } from "react-router-dom";
import React, { useContext, useEffect, useState } from 'react';
import { LoggedInUserContext } from '../AdminPageContainer';
import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { CorporateFare, Dns, Group, Leaderboard, SatelliteAlt, School, VerifiedUser } from '@mui/icons-material';
import { Roles } from 'src/Constants/BorgEnums';
import { colorAuriaYellow } from 'src/GlobalStyles/MuiTheme';

const ADMIN_MENU_ITEMS = [
  { title: 'Users', icon: <Group />, path: '/admin/users' },
  { title: 'Organizations', icon: <CorporateFare />, path: '/admin/organizations' },
  { title: 'Courses', icon: <School />, path: '/admin/courses' },
  { title: 'Sandboxes', icon: <SatelliteAlt />, path: '/admin/sandboxes' },
  { title: 'Leaderboards', icon: <Leaderboard />, path: '/admin/leaderboards' },
  { title: 'Permissions', icon: <VerifiedUser />, path: '/admin/permissions' },
  { title: 'System', icon: <Dns />, path: '/admin/system' }
];

const AdminSidebar: React.FC = () => {
  const location = useLocation();
  const loggedInUser = useContext(LoggedInUserContext)?.loggedInUser;   // Logged in User data (used for filtering pages)

  // Used to conditionaly filter menu items based on role and build type
  const isStandalone = process.env.REACT_APP_IS_STANDALONE === 'true';
  const isOrganizationAdmin = loggedInUser?.roles?.includes(Roles.OrganizationAdmin) ?? false;

  const [selectedPath, setSelectedPath] = useState<string>(location.pathname.split('/')[2] || ""); // Initialize based on the current location

  //Set selected path when menu item is chosen
  useEffect(() => {
    setSelectedPath(location.pathname);
  }, [location]);

  //#region 
  //Filter menu items based on user role
  let filteredMenuItems = ADMIN_MENU_ITEMS;

  if (isStandalone) {
    filteredMenuItems = filteredMenuItems.filter(item =>
      !['Organizations', 'Permissions'].includes(item.title)
    );
  }

  if (isOrganizationAdmin) {
    filteredMenuItems = filteredMenuItems.filter(item =>
      ['Users', 'Courses', 'Sandboxes'].includes(item.title)
    );
  }
  //#endregion

  return (
    <Box>
      <List className="admin-sidebar-menu-items">
        {filteredMenuItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              component={RouterLink}
              to={item.path} // Use string to get navigation path
              sx={{
                backgroundColor: selectedPath === item.path ? colorAuriaYellow : 'transparent', // Highlight on selection
                borderRadius: '30px', // Capsule effect
                padding: '8px 16px', // Add padding for the capsule
                margin: '4px 4px', // Add spacing between items
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedPath === item.path ? 'black' : '', // Highlight on selection
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                primaryTypographyProps={{
                  sx: {
                    color: selectedPath === item.path ? 'black' : '', // Change color based on selection
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default AdminSidebar;